import React from 'react';
import { InputProps, useInput, useTranslate } from 'react-admin';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { TERMS_AND_CONDITIONS_URL } from '../../constants';

const TermsCheckbox: React.FC<InputProps> = props => {
  const {
    field: { value, onChange, ...fieldProps },
  } = useInput(props);
  const t = useTranslate();

  return (
    <div className="flex items-start gap-2">
      <Checkbox
        id="terms"
        checked={!!value}
        onCheckedChange={checked => onChange(checked)}
        {...fieldProps}
      />
      <div className="flex flex-col gap-1 flex-1 min-w-0">
        <Label
          htmlFor="terms"
          className="text-sm font-normal leading-snug cursor-pointer text-foreground"
        >
          {t('offer.common.terms')}
        </Label>
        <span className="text-sm font-normal leading-snug text-muted-foreground">
          {t('offer.common.terms_link')}{' '}
          <a
            href={TERMS_AND_CONDITIONS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-foreground"
          >
            {t('common.text.here')}
          </a>
          {'.'}
        </span>
      </div>
    </div>
  );
};

export default TermsCheckbox;
